export const getFieldError = (error, touched) => {
  if (error && touched) {
    return error;
  }
  return null;
};

export default getFieldError;
